/* KeyvisualComponent component */
/* eslint-disable @typescript-eslint/no-unsafe-declaration-merging -- disabled to allow to inherit from AbstractComponent */
import { AbstractComponent } from '@cewe-designsystem/abstract';
import UtilBrowserDetection from '@cewe-designsystem/util_browser-detection';
import { Component, Element, h, Host, Prop } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars
import { DeviceType } from '@cewe-designsystem/util_browser-detection/dist';

@Component({
  tag: 'cwc-keyvisual',
  styleUrl: './styles/cwc-keyvisual.scss',
  shadow: true,
})
export class KeyvisualComponent {
  @Element() element: HTMLElement;

  @Prop() productId: number;
  @Prop() keyAccount: number;
  /** (optional) reversing the position of the download section and the brand visual */
  @Prop() reverse: boolean = false;
  @Prop() brandVisualLink: string | null = null;
  @Prop() brandVisualLinkTitle: string | null = null;

  @Prop({ reflect: true, mutable: true }) desktop: string;
  private browserDetection: UtilBrowserDetection;

  /**
   * Called every time the component is connected to the DOM.
   * When the component is first connected, this method is called before componentWillLoad.
   * It's important to note that this method can be called more than once, everytime, the element is attached or moved in the DOM.
   * This lifecycle hook follows the same semantics as the one described by the Custom Elements Spec
   */
  connectedCallback() {
    this.browserDetection = new UtilBrowserDetection();

    if (this.desktop === undefined) {
      // only detect if not set initially
      this.desktop = this.browserDetection.getDeviceType() === DeviceType.DESKTOP ? 'true' : 'false';
    }
  }

  /**
   * Called every time the component is disconnected from the DOM, ie, it call be dispatched more than once
   * DO not confuse with a "onDestroy" kind of event.
   * This lifecycle hook follows the same semantics as the one described by the Custom Elements Spec.
   */
  disconnectedCallback() {}

  /**
   * Called once just after the component is first connected to the DOM.
   * A promise can be returned, that can be used to wait for the first render.
   */
  componentWillLoad() {}

  /**
   * Called once just after the component fully loaded and the first render() occurs.
   */
  componentDidLoad() {}

  /**
   * Called before every render().
   * A promise can be returned, that can be used to wait for the upcoming render.
   */
  componentWillRender() {}

  /**
   * Called after every render().
   */
  componentDidRender() {}

  /**
   * Called when the component is about to be updated because some Prop() or State() changed.
   * It's never called during the first render().
   * A promise can be returned, that can be used to wait for the next render.
   */
  componentWillUpdate() {}

  /**
   * Called just after the component updates. It's never called during the first render().
   */
  componentDidUpdate() {}

  /**
   * render
   */
  render() {
    return (
      <Host
        class={{
          reverse: this.reverse,
        }}
      >
        <div class="brandvisual">
          {this.brandVisualLink ? (
            <a href={this.brandVisualLink} title={this.brandVisualLinkTitle}>
              <slot name="brandvisual-image" />
            </a>
          ) : (
            <slot name="brandvisual-image" />
          )}
        </div>

        <div class="download">
          <slot name={`download-content-desktop-row`} />
          <slot name={`download-content-desktop-column`} />
          <slot name={`download-content-mobile-row`} />
          <slot name={`download-content-mobile-column`} />
        </div>
      </Host>
    );
  }
}

/**
 * mixin abstract functions
 */
Object.setPrototypeOf(KeyvisualComponent.prototype, AbstractComponent.prototype);

export interface KeyvisualComponent extends AbstractComponent {}
